<template>
    <div class="content">
      <div class="contentMessage">
        <div class="leftBg">
          <div class="leftLogo">
            <img src="../assets/logo.png" />
            <span></span>
            <div>企业服务系统</div>
          </div>
          <img class="bg_img" src="../assets/bg_3.png" />
        </div>
        <div class="rightLogin">
          <template v-if="type == 'login'">
            <div class="rightBox">
              <div class="login">欢迎，登录企业服务系统</div>
                <el-input
                    @keyup.enter.native='login'
                    clearable
                    size="small"
                    placeholder="请输入手机号"
                    v-model="form.phone">
                    <div class="iconImg" slot="prefix">
                      <img src="../assets/icon_phone.png" />
                    </div>
                </el-input>
                <el-input
                    @keyup.enter.native='login'
                    :type="flag?'text':'password'"
                    size="small"
                    placeholder="请输入登录密码"
                    v-model="form.password">

                    <span slot="suffix"
                       :class="[flag?'openEye':'closeEye']"
                       style="cursor: pointer;"
                       autocomplete="auto"
                       @click="flag=!flag">
                    </span>
                    <div class="iconImg" slot="prefix">
                      <img src="../assets/icon_psw.png" />
                    </div>
                </el-input>
                <div style="display: flex;">
                  <el-input
                    @keyup.enter.native='login'
                    clearable
                    style="flex: 1;"
                    size="small"
                    type="text"
                    placeholder="请输入验证码"
                    v-model="form.authCode">
                    <div class="iconImg" slot="prefix">
                      <img src="../assets/icon_code.png" />
                    </div>
                  </el-input>
                  <el-button type="primary" class="code" @click="sendYzm" :disabled="countDisable" >{{ count }}</el-button>
                </div>
                <el-button type="primary" class="btn" @click="login">登录</el-button>
                <div class="goOther">
                  <div @click="forgotPass" class="forgotPass">忘记密码？</div>
                </div>
            </div>
          </template>
          <template v-if="type == 'forgotPass'">
            <ForgotPass @closeBtn="handelCloses"></ForgotPass>
          </template>
        </div>
      </div>
    </div>
</template>
<script>
import ForgotPass from "../components/forgotPass.vue"
import Identify from "../components/identify.vue";
export default {
    data() {
        return {
          isShow:false,
          isShowMask:false,
          type:"login",
          form:{
            phone:'',
            authCode:"",
            mobile:"",
            password:"",
          },
          merchant_id:'',
          count: "发送验证码",
		  waitTime:61,
          countDisable: false,
          type:"login",
          rePwdReadOnly:false,
          newPwdReadOnly:false,
          flag:false,
        };
    },
    components: {
        ForgotPass,
        Identify
    },
    destroyed() {
        clearInterval(this.inter);
    },
    created() {
    },
    methods:{
      goLogin(){
        this.$router.push({
            path: "/",
        });
        this.type = "login";
      },
      goRegister(){
        this.$router.push({
          name:'register'
        })
      },
      countDown() {
          let self = this;
          self.waitTime--
          self.countDisable = true;
          self.inter = setInterval(function () {
              // console.log("进来");
              if (self.waitTime > 1) {
                  self.countDisable = true;
                  self.waitTime--;
          				self.count = `${self.waitTime}s`
                  // console.log(self.count, "倒计时");
              } else {
                  clearInterval(self.inter);
                  self.count = "获取验证码";
                  self.countDisable = false;
                  self.inter = null;
          				self.waitTime = 61
              }
          }, 1000);
      },
      sendYzm() {
          let self = this;
          if (!this.form.phone) {
              this.$message({
                  message: "请输入手机号",
                  type: "warning",
              });
              return;
          }
          let data = {
              mobile: this.form.phone,
          };
          this.$http.post("api/sms", data).then((res) => {
              console.log(res, "返回验证码");
              if (res.code == 0) {
                this.countDown();
              } else {
                  self.count = "获取验证码";
                  self.countDisable = false;
                  this.$message({
                      message: res.message,
                      type: "warning",
                  });
              }
          });
      },
      handelCloses(){
        this.type = "login";
        this.count='获取验证码'
        clearInterval(this.inter);
        this.countDisable = false;
        this.inter = null;
        this.waitTime = 61
      },
      login(){
        if(this.form.authCode==''){
          this.$message({
              message: "请输入短信验证码",
              type: "warning",
          });
          return
        }
        let data = {
            username: this.form.phone,
            password:this.form.password,
            authCode:this.form.authCode,
        };

        this.$http.post("backend/tokens", data).then((res) => {
            console.log("登录获取用户信息----------------》", res, res.code);

            if (res.code == 0) {
                var token = res.data.token;
                this.$message({
                    message: "登录成功",
                    type: "success",
                });
                this.$router.push({
                    path: "/indexList",
                    query: {
                        superIndex: 0,
                        subIndex: 0,
                    },
                });
                sessionStorage.setItem("token", token);
                sessionStorage.setItem('subIndex',0)
                sessionStorage.setItem('subId',1)
            } else {
                this.$message({
                    message: res.message,
                    type: "warning",
                });
            }
        });
      },
      forgotPass(){
        this.type='forgotPass'
      },
    }
};
</script>
<style lang="less" scoped>
  .content{
    width: 100%;
    height: 100vh;
    /* overflow-y: auto; */
    display: flex;
    background: url('../assets/bg_1.png') no-repeat;
    background-size: 100% 100%;
    padding: 150px 0;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
  .content .contentMessage{
    width: 1200px;
    height: 600px;
    display: flex;
    background: #FFFFFF;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
  }
  .content .leftBg{
    /* flex: 1; */
    width: 640px;
    height: 100%;
    background: url('../assets/bg_2.png') no-repeat;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding: 40px;
    box-sizing: border-box;
  }
  .leftBg .bg_img{
    width: 520px;
    margin-left: 10px;
    margin-top: 33px;
  }
  .leftLogo{
    display: flex;
    align-items: center;
    img{
      width: 101px;
      margin-right: 4px;
      display: block;
    }
    span{
      width: 1px;
      height: 16px;
      display: block;
      background: #E2E4EB;
    }
    div{
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      padding-left: 8px;
    }
  }
  .content .rightLogin{
    flex: 1;
    height: 100%;
  }
  .content .rightLogin .rightBox{
    width: 320px;
    height: 400px;
    margin: 0 auto;
    margin-top: 120px;
    /* transform: translateY(-50%); */
  }
  .content .rightLogin .rightBox .login{
    font-size: 24px;
    font-weight: 500;
    color: #333;
    margin-bottom: 40px;
  }
  .content .rightLogin .rightBox .el-input{
    margin-bottom: 20px;
  }
  .content .rightLogin .rightBox .goOther{
    display: flex;
    justify-content: flex-end;
  }
  .content .rightLogin .rightBox .forgotPass{
    margin-top: 12px;
    text-align: right;
    font-size: 12px;
    font-weight: 400;
    color: #2F68FC;
    cursor: pointer;
  }
  .content .rightLogin .rightBox .code{
      width: 102px;
      height: 40px;
      text-align: center;
      background: #DB3323;
      border-radius: 2px;
      font-size: 14px;
      font-weight: 400;
      color: #FFFFFF;
      margin-left: 12px;
      padding: 0;
	  border: none;
      box-sizing: border-box;
    }
    /deep/ .el-button--primary.is-disabled{
      border: none;
    }
    /deep/ .el-input--prefix .el-input__inner{
      padding-left: 49px;
    }
    .iconImg{
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 7px;
      img{
        width: 16px;
        display: block;
        padding-right: 12px;
        border-right: 1px solid #E1E4E9;
      }

    }
  .content .rightLogin .rightBox .btn{
    width: 100%;
    height: 40px;
    background: #DB3323;
    border-radius: 2px;
    margin-top: 20px;
  }
  /deep/ .el-tabs__header{
    margin-bottom: 0;
  }
  /deep/ .dialogTabBusines .el-dialog__header{
    border-bottom: 1px solid #F0F0F0;
  }
  /deep/ .el-input--small .el-input__inner {
    height: 40px;
    line-height: 40px;
	border-radius: 2px;
  }
  /deep/ .el-tabs__nav{
    width: 100%;
  }
  /deep/ .el-tabs__active-bar{
    width: 50% !important;
  }
  /deep/ .el-tabs__item{
    width: 50%;
    text-align: center;
    font-size: 16px;
  }
  /deep/ .el-input__suffix{
    display: flex;
    align-items: center;
    right: 10px;
  }
  .closeEye{
    display: block;
    width: 16px;
    height: 16px;
    background: url(../assets/closeEye.png) no-repeat;
    background-size: 100% 100%;
  }
  .openEye{
    display: block;
    width: 16px;
    height: 16px;
    background: url(../assets/openEye.png) no-repeat;
    background-size: 100% 100%;
  }
  .videoWrapper{
    position: fixed;
    right: -1px;
    bottom: 200px;
    z-index: 100;
    .videoBg{
      width: 37px;
      height: 72px;
      border: 1px solid #fff;
      background: rgba(20, 27, 51, 0.60);
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      box-shadow: 0px 2px 4px 0px rgba(208,208,208,0.6);
      img{
        width: 20px;
        height: 20px;
      }
      div{
        margin-top: 6px;
        width: 24px;
        font-size: 12px;
        font-weight: 400;
        color: #FFFFFF;
      }
    }
    .videoBox{
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      z-index: 1000;
      .videoIcon{
        width: 16px;
        position: absolute;
        right: -26px;
        top: -26px;
        z-index: 100;
        cursor: pointer;
      }
      .videos{

        width: 800px;
      }
    }

  }
  .maskBox{
    width: 100%;
    height: 100%;
    background: #000;
    opacity: .5;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
  }
  /deep/ .el-tabs__nav-wrap:after{
    z-index: inherit;
  }
  /deep/ .el-tabs__item{
    z-index: inherit;
  }
  /deep/ .el-tabs__nav{
    // z-index: inherit;
  }
</style>



// WEBPACK FOOTER //
// src/page/login.vue